import { Uuid } from "@/domains/global/identifiers";
import { FeedbackModelData, IFeedbackModel } from "@/store/feedback/types";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { computed, makeObservable } from "mobx";
import { ApiSchema } from "@/modules/api";

export class FeedbackObservable extends BaseSyncModel<FeedbackModelData> implements IFeedbackModel {
  public modelKind = SyncModelKind.Feedback;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<FeedbackModelData> } & WithAppStore) {
    super({ id, data, store });
    makeObservable(this, {
      // PROPERTIES
      modelKind: false,
      spaceAccountId: computed,
      feedbackKind: computed,
      associatedModelId: computed,
      associatedModelKind: computed,
      associatedContext: computed,
      feedbackRespondedAt: computed,
      feedbackResponse: computed,
      feedbackSelectedSuggestions: computed,
      feedbackUserText: computed,
    });
  }

  get spaceAccountId(): string {
    return this.data.model_data.space_account_id;
  }

  get feedbackKind(): ApiSchema["FeedbackKind"] {
    return this.data.model_data.feedback_kind;
  }

  get associatedModelId(): string | null {
    return this.data.model_data.associated_model_id;
  }

  get associatedModelKind(): string | null {
    return this.data.model_data.associated_model_kind;
  }

  get associatedContext(): Record<string, unknown> {
    return this.data.model_data.associated_context;
  }

  get feedbackRespondedAt(): string | null {
    return this.data.model_data.feedback_responded_at;
  }

  get feedbackResponse(): ApiSchema["FeedbackResponseKind"] | null {
    return this.data.model_data.feedback_response;
  }

  get feedbackSelectedSuggestions(): string[] {
    return this.data.model_data.feedback_selected_suggestions;
  }

  get feedbackUserText(): string | null {
    return this.data.model_data.feedback_user_text;
  }
}
